import { useQuery } from '@tanstack/react-query'
import { statsApi } from '~/entities/stats/api/stats'
import { QueryKey, queryKey } from '~/shared/lib/query-keys'
import { MINUTES } from '~/shared/lib/time-constants'

export function useBusinessOverview(businessId: string) {
  return useQuery({
    queryKey: queryKey(QueryKey.BUSINESS_OVERVIEW, businessId),
    queryFn: () => statsApi.getBusinessOverview(businessId),
    staleTime: MINUTES,
    enabled: !!businessId,
  })
}
